import { render, staticRenderFns } from "./CollectionPointDeleteModal.vue?vue&type=template&id=2fef8fe4"
import script from "./CollectionPointDeleteModal.vue?vue&type=script&lang=js"
export * from "./CollectionPointDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointDeleteModal.vue?vue&type=style&index=0&id=2fef8fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports